<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">

        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('Taxes') }}</div>
            <AddNewButton v-show="canModerate"
                          :disabled="dataTableIsLoading || items?.length >= 10"
                          :loading="dataTableIsLoading"
                          :label="$t('Add')"
                          @click="addNewItem" />
          </template>
        </Toolbar>

        <Spinner v-if="isLoading"/>
        <DesktopDataTable v-else
                          :showHeader="false"
                          :dataTableIsLoading="dataTableIsLoading"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'value', title: $t('Value'), sortable: true},
              {name: 'name', title: $t('Name'),sortable: false},
              {name: 'status', title: $t('active'), sortable: false},
              {name: 'valid_until', title: $t('Valid until'), sortable: false},
              {name: 'created_at', title: $t('Created'), width: '20%', sortable: true},
          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                <span v-if="item.value">{{ formatDecimal(item.value) }}%</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <i class="pi pi-check green-color" v-if="item.status === 1"/>
                <i class="pi pi-times warning-color" v-else/>
              </td>
              <td>
                <span v-if="item.valid_until">{{ formatDate(item.valid_until) }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td class="table-date-line">
                {{ formatBy(item.created_at, item.creator) }}
              </td>
              <td v-show="actionButtonsCount">
                <div class="actions">
                  <EditButton v-show="canModerate"
                              :disabled="dataTableIsLoading" @click="editItem(item)" />
                  <DeleteButton v-show="canModerate"
                                @click="confirmItemDelete(item)"
                                :disabled="dataTableIsLoading"/>
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="items && items.length"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>


        <TaxModal :visible="itemModal"
                  :item="item"
                  @update-items="updateItems"
                  @close="closeItemModal"/>

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            :modalDataIsLoading="modalDataIsLoading"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"
                            :data="itemToDeleteData"/>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import TaxModal from '@/pages/data_directory/components/TaxModal'
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import formatMixins from "@/mixins/formatMixins";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [ showErrorsMixins, datatableMixins, formatMixins ],
  components: { TaxModal },
	data() {
		return {
      fieldsExpand: 'creator',
      apiLink: 'tax',
      deleteItemUrl: 'tax/delete',
      routePath: '/taxes',
      sort: {
        column: 'id',
        direction: '-',
      },
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems()
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('taxes')
      try {
        // const { status, data, headers } = await httpClient(`${this.apiLink}?page=${this.pagination.currentPage}&per-page=${this.pagination.perPage}&sort=${this.sort.direction + this.sort.column}&search=${this.searchData}&expand=${this.fieldsExpand}`)
        const { status, data, headers } = await httpClient({
          // const { data } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.taxes === ctrl) {
          this._abortors.taxes = null
        }
      }
    },
	},
  computed: {
    canModerate() {
      return this.$store.getters.isAccountantOrHigher
    },
    actionButtonsCount() {
      return this.canModerate ? 2 : 0
    },
  }
}
</script>
<style scoped lang="scss">
td {
  height: 44px
}
</style>